import React, { useContext, useEffect, useState } from "react";
import PatientDetails from "../../Components/PatientInformation";
import SaveAndNavigate from "../../Components/SaveAndNavigate";
import {
  SideMenuItems,
  HTTPResponse,
  ToastMessageType,
  ToastMessages,
  PageDesignConstants,
} from "../../Helpers/Enums";
import SideBarMenu from "../../Components/SideBarMenu";
import ErrorField from "../../Components/ErrorField";
import {
  CommonError_Msgs,
  EligibilityCriteria_Msgs,
} from "../../Helpers/HelperText";
import { AppContext } from "../../Contexts/AppContextProvider";
import {
  AddLocalStorageData,
  GetLocalStorageData,
  GetLoggedInUserID,
  isStringEmpty,
} from "../../Helpers/Utilities";
import { EligibilityCriteriaService } from "../../WebApiServices/EligibilityCriteria.service";

const ExclusionCriteria = () => {
  const [isEligible, setIsEligible] = useState(false);
  const [isAllDataFilled, setIsAllDataFilled] = useState(false);
  const [isNewEcrfA, setIsNewEcrfA] = useState(false);

  const pid = GetLocalStorageData("patientId") ?? 0;
  let patientData = GetLocalStorageData("patient");
  patientData = patientData && JSON.parse(patientData);
  const eligibilityCriteriaLocked =
    patientData?.eligibilityCriteriaLocked ?? false;

  const cohortTreatmentData = GetLocalStorageData("CohortTreatment");

  const cohortTreatmentList = Array.isArray(
    JSON.parse(cohortTreatmentData || "[]"),
  )
    ? JSON.parse(cohortTreatmentData)
    : [];

  const shouldShowBiSpecificInitiationPage = cohortTreatmentList.some(
    (item) => item?.monoTherapyReceived === false && item?.isEligible === true,
  );

  const {
    ShowToast,
    ToggleLoader,
    HandleSessionTimeout,
    isSideMenuActive,
    setIsSideMenuActive,
    patientConfigData,
  } = useContext(AppContext);
  const terminatedPageId = patientConfigData?.data?.terminatedPageId;

  const navigatePaths = {
    prevPage:
      shouldShowBiSpecificInitiationPage && isNewEcrfA
        ? "/RRMMComboTherapy"
        : "/RRMMCriteria",
    currPage: "/ExclusionCriteria",
    nextPage:
      terminatedPageId === SideMenuItems.ExclusionCriteria
        ? "/ManagePatients"
        : eligibilityCriteriaLocked
          ? "/TransitionToChartAbstraction"
          : isAllDataFilled && isEligible
            ? "/TransitionToChartAbstraction"
            : isAllDataFilled && !isEligible
              ? "/ManagePatients"
              : "/ExclusionCriteria",
  };

  const centerId = patientData?.ptCenterId ?? 0;
  const [ptEligibilityId, setPtEligibilityId] = useState(null);
  const [eligibilityDisabled, seteligibilityDisabled] = useState(false);

  const [showTopErrMsg, setShowTopErrMsg] = useState(false);

  useEffect(() => {
    async function FetchData() {
      if (!isNaN(pid) && Number(pid) !== 0) {
        ToggleLoader(true);
        await LoadData();
        ToggleLoader(false);
      }
    }
    FetchData();
  }, []);

  const RepeaterRow = {
    exclusionCriteriaId: null,
    cohortTreatmentId: 0,
    cohortTreatmentName: "",
    cohortTreatmentNameSuperscript: "",
    s13: null,
    s14: null,
    s13_hard_err: false,
    s14_hard_err: false,
    s13_soft_err: false,
    s14_soft_err: false,
    s14_clinicalTrialReceived: null,
    s14_clinicalTrialReceived_err: false,
    isCartTCohort: false,
  };

  const [criteriaExclusion, setCriteriaExclusion] = useState([RepeaterRow]);
  const [metInclusionCriteria, setMetInclusionCriteria] = useState(null);

  async function LoadData() {
    try {
      if (pid > 0) {
        const response =
          await EligibilityCriteriaService.LoadExclusionCriteria(pid);

        if (response?.status === HTTPResponse.OK) {
          const { data } = response;
          setIsNewEcrfA(data.isNewEcrfA ?? false);
          setMetInclusionCriteria(data.metInclusionCriteria);
          setPtEligibilityId(data.patientEligibilityId);
          seteligibilityDisabled(data.eligibilityLocked);

          const storedData = GetLocalStorageData("CohortTreatment");

          if (storedData) {
            let cohortTreatmentList = [];
            cohortTreatmentList = JSON.parse(storedData);

            //Cohort treatments present
            if (cohortTreatmentList && cohortTreatmentList.length > 0) {
              let exclusionCriteriaList = [];
              //data present in db
              if (
                data.exclusionCriteriaList &&
                data.exclusionCriteriaList.length > 0
              ) {
                exclusionCriteriaList = cohortTreatmentList.map((ct) => {
                  let exclusionCriteriaId = null;
                  let s13 = null;
                  let s14 = null;
                  let s14_clinicalTrialReceived = null;
                  let isCartTCohort =
                    NON_EXCLUSION_COHORTS.includes(ct.cohortTreatmentName) ??
                    false;
                  let s14_soft_err = false;
                  //Check if data is present for a cohort tmt
                  const dbRow = data.exclusionCriteriaList.find(
                    (a) => a.cohortTreatmentId === ct.cohortTreatmentID,
                  );
                  if (dbRow) {
                    exclusionCriteriaId = dbRow.exclusionCriteriaId;
                    s13 = dbRow.responseassessmentNdmmcart
                      ? 1
                      : dbRow.responseassessmentNdmmcart === false
                        ? 0
                        : null;
                    s14 = dbRow.clinicaltrialNdmmcart
                      ? 1
                      : dbRow.clinicaltrialNdmmcart === false
                        ? 0
                        : null;
                    s14_clinicalTrialReceived =
                      dbRow.clinicalTrialReceived ?? null;

                    s14_soft_err =
                      s14 === 1 &&
                      (!isCartTCohort || dbRow.clinicalTrialReceived === 1);
                  }
                  return {
                    ...RepeaterRow,
                    exclusionCriteriaId,
                    cohortTreatmentId: ct.cohortTreatmentID,
                    cohortTreatmentName:
                      ct.cohortTreatmentName === "DKRd (TE or TIE)"
                        ? ct.cohortTreatmentSCT === 1
                          ? "DKRd (TE)"
                          : ct.cohortTreatmentSCT === 2
                            ? "DKRd (TIE)"
                            : ct.cohortTreatmentName
                        : ct.cohortTreatmentName,
                    cohortTreatmentNameSuperscript:
                      ct.cohortTreatmentNameSuperscript,
                    s13,
                    s14,
                    s13_soft_err: s13 === 0,
                    s14_soft_err,
                    s14_clinicalTrialReceived,
                    isCartTCohort,
                  };
                });
              } else {
                exclusionCriteriaList = cohortTreatmentList.map((ct) => ({
                  ...RepeaterRow,
                  cohortTreatmentId: ct.cohortTreatmentID,
                  cohortTreatmentName: ct.cohortTreatmentName,
                  cohortTreatmentNameSuperscript:
                    ct.cohortTreatmentNameSuperscript,
                }));
              }
              setCriteriaExclusion(exclusionCriteriaList);
            }
          }

          //set CohortTreatment in Local storage
          if (data.cohortTreatmentModelList.length > 0)
            AddLocalStorageData(
              "CohortTreatment",
              JSON.stringify(data.cohortTreatmentModelList),
            );
          else AddLocalStorageData("CohortTreatment", JSON.stringify([]));
        } else if (response?.status === HTTPResponse.Unauthorized) {
          HandleSessionTimeout();
        }
      }
    } catch (error) {
      ShowToast(CommonError_Msgs.LOAD_ERR, ToastMessageType.Failed);
    }
  }

  const NON_EXCLUSION_COHORTS = [
    "Ciltacabtagene autoleucel",
    "Idecabtagene vicleucel",
  ];

  const HandleRepeaterFieldChange = (e, row, index) => {
    const { name, value } = e.target;
    const valueInt = Number(value);
    setCriteriaExclusion((prev) => {
      const updated = [...prev];
      const updatedRow = { ...row }; // clone the row

      if (name.startsWith("S13_EXCLUSION")) {
        updatedRow.s13 = valueInt;
        updatedRow.s13_hard_err = false;
        updatedRow.s13_soft_err = valueInt === 0;
      }

      if (name.startsWith("S14_EXCLUSION")) {
        updatedRow.s14 = valueInt;
        updatedRow.s14_hard_err = false;

        const isCarTCohort = NON_EXCLUSION_COHORTS.includes(
          updatedRow.cohortTreatmentName,
        );
        updatedRow.s14_soft_err = valueInt === 1 && !isCarTCohort;
        updatedRow.isIneligible = valueInt === 1 && !isCarTCohort;
        updatedRow.isCartTCohort = valueInt === 1 && isCarTCohort;

        updatedRow.s14_clinicalTrialReceived = null;
        updatedRow.s14_clinicalTrialReceived_err = false;
      }

      if (name.startsWith("s14_clinicalTrialReceived")) {
        updatedRow.s14_clinicalTrialReceived = valueInt;
        updatedRow.s14_clinicalTrialReceived_err = false;

        updatedRow.s14_soft_err = valueInt === 1;
        updatedRow.isIneligible = valueInt === 1;
      }

      updated[index] = updatedRow; // update the array
      return updated;
    });
  };

  const ValidateForm = () => {
    let result = true;
    if (criteriaExclusion && criteriaExclusion.length > 0) {
      const validExclusionCriteria = criteriaExclusion.map((row) => {
        const s13_hard_err = row.s13 == null;
        const s14_hard_err = row.s14 == null;
        let s14_clinicalTrialReceived_err = false;

        if (s13_hard_err || s14_hard_err) {
          result = false;
        }

        const isCarTCohort = NON_EXCLUSION_COHORTS.includes(
          row.cohortTreatmentName,
        );

        if (
          row.s14 === 1 &&
          isCarTCohort &&
          row.s14_clinicalTrialReceived === null &&
          isNewEcrfA
        ) {
          s14_clinicalTrialReceived_err = true;
          result = false;
        }
        return {
          ...row,
          s13_hard_err,
          s14_hard_err,
          s14_clinicalTrialReceived_err,
        };
      });
      setCriteriaExclusion(validExclusionCriteria);
    }

    setIsAllDataFilled(result);
    return result;
  };

  function IsTerminated() {
    // Check if all cohorts are ineligible (s13 no OR s14 yes)
    // for catT if s14 is yes then check for sub options and if s14_clinicalTrialReceived === 1 then terminate
    return criteriaExclusion.every((item) => {
      // Rule 1: S13 = No → ineligible
      if (item.s13 === 0) return true;

      // Rule 2: S14 = Yes
      if (item.s14 === 1) {
        const isCarTCohort = NON_EXCLUSION_COHORTS.includes(
          item.cohortTreatmentName,
        );

        // Non-CAR-T → ineligible
        if (!isCarTCohort) return true;

        if (!isNewEcrfA) return true;

        // CAR-T → ineligible only if clinical trial
        return item.s14_clinicalTrialReceived === 1;
      }

      // Otherwise eligible
      return false;
    });
  }

  const SavePage = async () => {
    try {
      ToggleLoader(true);

      if (!ValidateForm()) {
        setShowTopErrMsg(true);
        ToggleLoader(false);
        return false;
      }

      setShowTopErrMsg(false);
      const isIncluded = !IsTerminated();
      setMetInclusionCriteria(isIncluded);

      const exclusionCriteriaData = criteriaExclusion.map((item) => ({
        ExclusionCriteriaId: item.exclusionCriteriaId ?? 0,
        CohortTreatmentId: item.cohortTreatmentId,
        ResponseassessmentNdmmcart: item.s13,
        ClinicaltrialNdmmcart: item.s14,
        ClinicalTrialReceived: item.s14_clinicalTrialReceived,
      }));

      const exclusionCriteriaModel = {
        PatientId: pid,
        CenterId: centerId,
        PatientEligibilityId: ptEligibilityId,
        UserId: GetLoggedInUserID(),
        MetInclusionCriteria: isIncluded,
        ExclusionCriteriaList: exclusionCriteriaData,
      };
      setIsEligible(isIncluded);

      if (pid > 0) {
        let response = await EligibilityCriteriaService.SaveExclusionCriteria(
          exclusionCriteriaModel,
        );

        if (response.status !== HTTPResponse.OK) {
          if (response?.status === HTTPResponse.Unauthorized) {
            HandleSessionTimeout();
          } else {
            throw response.error;
          }
        } else {
          ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);
          await LoadData();

          if (isIncluded)
            navigatePaths.nextPage = "/TransitionToChartAbstraction";
        }

        ToggleLoader(false);
      }
      return true;
    } catch (error) {
      ToggleLoader(false);
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    }
  };

  const sidebar = document.getElementById("mySidebar");
  const main = document.getElementById("main");

  const toggleNav = () => {
    if (isSideMenuActive === true) {
      sidebar.style.width = "0";
      main.style.marginLeft = "0";
      setIsSideMenuActive(false);
    } else if (isSideMenuActive === false) {
      sidebar.style.width = "350px";
      main.style.marginLeft = "350px";
      setIsSideMenuActive(true);
    }
  };

  useEffect(() => {
    const sidebar = document.getElementById("mySidebar");
    const main = document.getElementById("main");

    if (isSideMenuActive === true) {
      sidebar.style.width = "350px";
      main.style.marginLeft = "350px";
    } else {
      sidebar.style.width = "0";
      main.style.marginLeft = "0";
    }
  });
  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
          </div>
        </div>
      </section>
      <section className="main-survey-section">
        <div>
          <SideBarMenu activePageId={SideMenuItems.ExclusionCriteria} />
          <button
            className={isSideMenuActive ? "openbtn" : "openbtn active"}
            onClick={() => toggleNav()}
          >
            <i
              id="arrowNavigation"
              className="fa fa-arrow-left"
              aria-hidden="true"
            ></i>
          </button>
          <div className="col-pad-left eligibiltylocked" id="main">
            <div className="survey-section-content">
              <div className="survey-section-content-header">
                <h4>ADDITIONAL EXCLUSION CRITERIA</h4>
              </div>

              {!showTopErrMsg &&
                pid != 0 &&
                metInclusionCriteria != null &&
                metInclusionCriteria == false && (
                  <div className="clean-error">
                    <p>{EligibilityCriteria_Msgs.IneligiblePatient}</p>
                  </div>
                )}

              {showTopErrMsg && (
                <div className="clean-error">
                  <ErrorField
                    show={showTopErrMsg}
                    message={CommonError_Msgs.Hard_Empty}
                  />
                </div>
              )}
              <div
                className="survey-question-section"
                disabled={eligibilityDisabled}
              >
                <div className="survey-question-content">
                  <div className="question-answer">
                    {criteriaExclusion &&
                      criteriaExclusion.length > 0 &&
                      criteriaExclusion.map((cohort, index) => (
                        <div className="dependent-section" key={index}>
                          <div className="cohort-header">
                            <span>
                              {cohort.cohortTreatmentName}
                              {!isStringEmpty(
                                cohort.cohortTreatmentNameSuperscript,
                              ) && (
                                <>
                                  <sup className="supscript">
                                    {cohort.cohortTreatmentNameSuperscript.slice(
                                      0,
                                      2,
                                    )}
                                  </sup>
                                  {cohort.cohortTreatmentNameSuperscript.slice(
                                    2,
                                  )}
                                </>
                              )}
                            </span>
                          </div>
                          <div className="question-bottom-space">
                            <div className="question question-weight">
                              <span>S13.</span>
                              <span className="quest-text-pad">
                                Did patient receive ≥1 follow-up assessment
                                (e.g., response assessment, laboratory
                                assessment, medical encounter, etc.) after
                                initiating{" "}
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                  }}
                                >
                                  {cohort.cohortTreatmentName}
                                  {cohort.cohortTreatmentNameSuperscript ==
                                  null ? (
                                    ""
                                  ) : (
                                    <>
                                      <sup className="supscript">
                                        {cohort.cohortTreatmentNameSuperscript.slice(
                                          0,
                                          2,
                                        )}
                                      </sup>
                                      {cohort.cohortTreatmentNameSuperscript.slice(
                                        2,
                                      )}
                                    </>
                                  )}
                                </span>
                                ?
                              </span>
                            </div>
                            <div className="double-dig-answer">
                              <div className="option-without-input">
                                <label>
                                  <input
                                    type="radio"
                                    id={index}
                                    name={"S13_EXCLUSION" + index}
                                    value={1}
                                    checked={cohort.s13 === 1}
                                    onChange={(e) =>
                                      HandleRepeaterFieldChange(
                                        e,
                                        cohort,
                                        index,
                                      )
                                    }
                                  />
                                  <span className="radio-text-padding">
                                    Yes
                                  </span>
                                </label>
                              </div>
                              <div className="option-without-input">
                                <label>
                                  <input
                                    type="radio"
                                    id={index}
                                    name={"S13_EXCLUSION" + index}
                                    value={0}
                                    checked={cohort.s13 === 0}
                                    onChange={(e) =>
                                      HandleRepeaterFieldChange(
                                        e,
                                        cohort,
                                        index,
                                      )
                                    }
                                  />
                                  <span className="radio-text-padding">No</span>
                                </label>
                              </div>
                            </div>
                            <ErrorField
                              show={cohort.s13_soft_err}
                              message={
                                EligibilityCriteria_Msgs.CohortIneligible
                              }
                            />
                            <ErrorField
                              show={cohort.s13_hard_err}
                              message={EligibilityCriteria_Msgs.s13}
                            />
                          </div>
                          <div className="question-bottom-space">
                            <div className="question question-weight">
                              <span>S14.</span>
                              <span className="quest-text-pad">
                                Did the patient receive any part of{" "}
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                  }}
                                >
                                  {cohort.cohortTreatmentName}
                                  {cohort.cohortTreatmentNameSuperscript ==
                                  null ? (
                                    ""
                                  ) : (
                                    <>
                                      <sup className="supscript">
                                        {cohort.cohortTreatmentNameSuperscript.slice(
                                          0,
                                          2,
                                        )}
                                      </sup>
                                      {cohort.cohortTreatmentNameSuperscript.slice(
                                        2,
                                      )}
                                    </>
                                  )}
                                </span>{" "}
                                as part of a clinical trial or expanded access
                                program (EAP)?
                              </span>
                            </div>
                            <div className="double-dig-answer">
                              <div className="">
                                <div className="option-without-input">
                                  <label>
                                    <input
                                      type="radio"
                                      id={index}
                                      name={"S14_EXCLUSION" + index}
                                      value={1}
                                      checked={cohort.s14 === 1}
                                      onChange={(e) =>
                                        HandleRepeaterFieldChange(
                                          e,
                                          cohort,
                                          index,
                                        )
                                      }
                                    />
                                    <span className="radio-text-padding">
                                      Yes
                                    </span>
                                  </label>
                                </div>
                                {isNewEcrfA &&
                                  cohort.s14 === 1 &&
                                  cohort.isCartTCohort && (
                                    <div
                                      className="mb-1"
                                      style={{
                                        marginLeft: "10px",
                                        padding: "10px 20px",
                                      }}
                                    >
                                      <div className="option-without-input">
                                        <label>
                                          <input
                                            type="radio"
                                            id={index}
                                            name={
                                              "s14_clinicalTrialReceived" +
                                              index
                                            }
                                            value={1}
                                            checked={
                                              cohort.s14_clinicalTrialReceived ===
                                              1
                                            }
                                            onChange={(e) =>
                                              HandleRepeaterFieldChange(
                                                e,
                                                cohort,
                                                index,
                                              )
                                            }
                                          />
                                          <span className="radio-text-padding">
                                            Received as part of a clinical trial
                                          </span>
                                        </label>
                                      </div>
                                      <div className="option-without-input">
                                        <label>
                                          <input
                                            type="radio"
                                            id={index}
                                            name={
                                              "s14_clinicalTrialReceived" +
                                              index
                                            }
                                            value={2}
                                            checked={
                                              cohort.s14_clinicalTrialReceived ===
                                              2
                                            }
                                            onChange={(e) =>
                                              HandleRepeaterFieldChange(
                                                e,
                                                cohort,
                                                index,
                                              )
                                            }
                                          />
                                          <span className="radio-text-padding">
                                            Received as part of an EAP
                                          </span>
                                        </label>
                                      </div>

                                      <ErrorField
                                        style={{
                                          marginTop: "10px",
                                          paddingLeft: "0px",
                                        }}
                                        show={
                                          cohort.s14_clinicalTrialReceived_err
                                        }
                                        message={EligibilityCriteria_Msgs.Radio}
                                      />
                                    </div>
                                  )}
                              </div>
                              <div className="option-without-input">
                                <label>
                                  <input
                                    type="radio"
                                    id={index}
                                    name={"S14_EXCLUSION" + index}
                                    value={0}
                                    checked={cohort.s14 === 0}
                                    onChange={(e) =>
                                      HandleRepeaterFieldChange(
                                        e,
                                        cohort,
                                        index,
                                      )
                                    }
                                  />
                                  <span className="radio-text-padding">No</span>
                                </label>
                              </div>
                            </div>
                            <ErrorField
                              show={cohort.s14_soft_err}
                              message={
                                EligibilityCriteria_Msgs.CohortIneligible
                              }
                            />
                            <ErrorField
                              show={cohort.s14_hard_err}
                              message={EligibilityCriteria_Msgs.s14}
                            />
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>

              <div className="survey-section-content-foot">
                <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ExclusionCriteria;
